var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "location_2",
    "data-name": "location 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8.59 11.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .location-1 {\n        fill: #AE9048;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location_1",
    "data-name": "location 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "location-1",
    d: "M4.3,2.81c-.71,0-1.28.57-1.28,1.28s.57,1.28,1.28,1.28,1.28-.57,1.28-1.28-.57-1.28-1.28-1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "location-1",
    d: "M4.3,0C1.92,0,0,1.92,0,4.3c0,2.02,3.12,5.68,4.04,6.72.13.15.37.15.5,0,.92-1.03,4.04-4.7,4.04-6.72C8.59,1.92,6.67,0,4.3,0ZM4.3,6.22c-1.17,0-2.12-.95-2.12-2.12s.95-2.12,2.12-2.12,2.12.95,2.12,2.12-.95,2.12-2.12,2.12Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationBubble);
export default __webpack_public_path__ + "static/media/location-bubble.2443bc46d745cb2e0b08bc10d275a703.svg";
export { ForwardRef as ReactComponent };